import { listItemButtonClasses } from "@mui/material"

export const centerBoxStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
}

export const textLogoStyle = {
  fontSize: 24,
  fontWeight: 700,
}

export const logoWrapperStyle = {
  display: "flex",
  gap: 2,
  alignItems: "end",
}

export const textLogoDrawerStyle = {
  fontSize: 24,
  fontWeight: 700,
}

export const buttonConnectWalletStyle = {
  padding: "0.25rem 0.75rem",
  borderRadius: 12,
  backgroundColor: "black",
  fontSize: "1rem",
  fontWeight: 600,
  color: "white",
}

export const launchAppButton = {
  background: "black",
  fontWeight: 600,
  fontSize: { xs: 12, sm: 16 },
}

export const docsButton = {
  py: 0,
  pl: 0,
  pr: 2,
}

export const docsButtonCollapse = {
  py: 0,
  px: 2,
}

export const collapseList = {
  mt: 0.5,
  [`.${listItemButtonClasses.root}`]: {
    marginBottom: 1,
  },
}
